const STORAGE_KEY = 'gp_disable_shipping';

let memoryCache: boolean | undefined;
const listeners = new Set<() => void>();

function readStorage(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function writeStorage(on: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    if (on) window.sessionStorage.setItem(STORAGE_KEY, '1');
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage disabled — keep memory cache only
  }
}

function notify(): void {
  for (const cb of listeners) cb();
}

export function loadShippingDisabled(): boolean {
  if (memoryCache !== undefined) return memoryCache;
  memoryCache = readStorage();
  return memoryCache;
}

export function saveShippingDisabled(on: boolean | undefined): void {
  const next = on === true;
  if (memoryCache === undefined) memoryCache = readStorage();
  if (memoryCache === next) return;
  memoryCache = next;
  writeStorage(next);
  notify();
}

export function clearShippingDisabled(): void {
  if (memoryCache === undefined) memoryCache = readStorage();
  if (memoryCache === false) return;
  memoryCache = false;
  writeStorage(false);
  notify();
}

export function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
